/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {ChecklistTemplateQuantitativeDriverDTO} from './ChecklistTemplateQuantitativeDriverDTO';

/**
 * The ChecklistPostRequestDTO model module.
 * @module model/ChecklistPostRequestDTO
 * @version v0
 */
export class ChecklistPostRequestDTO {
  /**
   * Constructs a new <code>ChecklistPostRequestDTO</code>.
   * @alias module:model/ChecklistPostRequestDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistPostRequestDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistPostRequestDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistPostRequestDTO} The populated <code>ChecklistPostRequestDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistPostRequestDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('legalEntityParentCompanyId'))
        obj.legalEntityParentCompanyId = ApiClient.convertToType(data['legalEntityParentCompanyId'], 'Number');
      if (data.hasOwnProperty('legalEntitySubsidiaryId'))
        obj.legalEntitySubsidiaryId = ApiClient.convertToType(data['legalEntitySubsidiaryId'], 'Number');
      if (data.hasOwnProperty('legalEntityCompanyId'))
        obj.legalEntityCompanyId = ApiClient.convertToType(data['legalEntityCompanyId'], 'Number');
      if (data.hasOwnProperty('legalEntityRegionId'))
        obj.legalEntityRegionId = ApiClient.convertToType(data['legalEntityRegionId'], 'Number');
      if (data.hasOwnProperty('controlFunctionId'))
        obj.controlFunctionId = ApiClient.convertToType(data['controlFunctionId'], 'Number');
      if (data.hasOwnProperty('operationalScopeIds'))
        obj.operationalScopeIds = ApiClient.convertToType(data['operationalScopeIds'], ['Number']);
      if (data.hasOwnProperty('checklistTemplateQuantitativeDrivers'))
        obj.checklistTemplateQuantitativeDrivers = ApiClient.convertToType(data['checklistTemplateQuantitativeDrivers'], [ChecklistTemplateQuantitativeDriverDTO]);
      if (data.hasOwnProperty('fiscalYear'))
        obj.fiscalYear = ApiClient.convertToType(data['fiscalYear'], 'Number');
      if (data.hasOwnProperty('supervisedEntity'))
        obj.supervisedEntity = ApiClient.convertToType(data['supervisedEntity'], 'Boolean');
      if (data.hasOwnProperty('qualitativeOnly'))
        obj.qualitativeOnly = ApiClient.convertToType(data['qualitativeOnly'], 'Boolean');
      if (data.hasOwnProperty('qualitativeWeight'))
        obj.qualitativeWeight = ApiClient.convertToType(data['qualitativeWeight'], 'Number');
      if (data.hasOwnProperty('quantitativeWeight'))
        obj.quantitativeWeight = ApiClient.convertToType(data['quantitativeWeight'], 'Number');
      if (data.hasOwnProperty('coverage'))
        obj.coverage = ApiClient.convertToType(data['coverage'], 'Number');
      if (data.hasOwnProperty('accuracy'))
        obj.accuracy = ApiClient.convertToType(data['accuracy'], 'Number');
      if (data.hasOwnProperty('visibleOnBI'))
        obj.visibleOnBI = ApiClient.convertToType(data['visibleOnBI'], 'Boolean');
      if (data.hasOwnProperty('freezeState'))
        obj.freezeState = ApiClient.convertToType(data['freezeState'], 'Boolean');
      if (data.hasOwnProperty('checklistPeriodId'))
        obj.checklistPeriodId = ApiClient.convertToType(data['checklistPeriodId'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistPostRequestDTO.prototype.id = undefined;

/**
 * @member {Number} legalEntityParentCompanyId
 */
ChecklistPostRequestDTO.prototype.legalEntityParentCompanyId = undefined;

/**
 * @member {Number} legalEntitySubsidiaryId
 */
ChecklistPostRequestDTO.prototype.legalEntitySubsidiaryId = undefined;

/**
 * @member {Number} legalEntityCompanyId
 */
ChecklistPostRequestDTO.prototype.legalEntityCompanyId = undefined;

/**
 * @member {Number} legalEntityRegionId
 */
ChecklistPostRequestDTO.prototype.legalEntityRegionId = undefined;

/**
 * @member {Number} controlFunctionId
 */
ChecklistPostRequestDTO.prototype.controlFunctionId = undefined;

/**
 * @member {Array.<Number>} operationalScopeIds
 */
ChecklistPostRequestDTO.prototype.operationalScopeIds = undefined;

/**
 * @member {Array.<module:model/ChecklistTemplateQuantitativeDriverDTO>} checklistTemplateQuantitativeDrivers
 */
ChecklistPostRequestDTO.prototype.checklistTemplateQuantitativeDrivers = undefined;

/**
 * @member {Number} fiscalYear
 */
ChecklistPostRequestDTO.prototype.fiscalYear = undefined;

/**
 * @member {Boolean} supervisedEntity
 */
ChecklistPostRequestDTO.prototype.supervisedEntity = undefined;

/**
 * @member {Boolean} qualitativeOnly
 */
ChecklistPostRequestDTO.prototype.qualitativeOnly = undefined;

/**
 * @member {Number} qualitativeWeight
 */
ChecklistPostRequestDTO.prototype.qualitativeWeight = undefined;

/**
 * @member {Number} quantitativeWeight
 */
ChecklistPostRequestDTO.prototype.quantitativeWeight = undefined;

/**
 * @member {Number} coverage
 */
ChecklistPostRequestDTO.prototype.coverage = undefined;

/**
 * @member {Number} accuracy
 */
ChecklistPostRequestDTO.prototype.accuracy = undefined;

/**
 * @member {Boolean} visibleOnBI
 */
ChecklistPostRequestDTO.prototype.visibleOnBI = undefined;

/**
 * @member {Boolean} freezeState
 */
ChecklistPostRequestDTO.prototype.freezeState = undefined;

/**
 * @member {Number} checklistPeriodId
 */
ChecklistPostRequestDTO.prototype.checklistPeriodId = undefined;

